//DoctorForm.jsx
import Typography from '@mui/material/Typography';
import { Avatar, Alert, Button, Grid, Snackbar, styled } from '@mui/material';
import { SimpleCard } from 'app/components';
import { Span } from 'app/components/Typography';
import { useState } from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import useAuth from 'app/hooks/useAuth';
import { addSpecialist, updateSpecialist } from 'app/api-ws/specialists-ws';

const TextField = styled(TextValidator)(() => ({
  width: '100%',
  marginBottom: '16px'
}));

const SpecialistForm = ({
  specialist,
  setProfileImage,
  profileImage,
  handleCloseDialog,
  handleDialogSubmit,
  fetchSpecialistDetails
}) => {
  const [consultantName, setConsultantName] = useState({
    firstName: specialist?.consultantName?.firstName || '',
    lastName: specialist?.consultantName?.lastName || ''
  });
  const [email, setEmail] = useState(specialist?.email);
  const [phoneNumber, setPhoneNumber] = useState({
    cell: specialist?.phoneNumber?.cell || '',
    whatsapp: specialist?.phoneNumber?.whatsapp || ''
  });

  const [centerAddress, setCenterAddress] = useState({
    centerName: specialist?.centerAddress?.centerName || '',
    street: specialist?.centerAddress?.street || '',
    locality: specialist?.centerAddress?.locality || '',
    district: specialist?.centerAddress?.district || '',
    state: specialist?.centerAddress?.state || 'Karnataka',
    pincode: specialist?.centerAddress?.pincode || ''
  });
  const [aboutSpecialist, setAboutSpecialist] = useState({
    qualification: specialist?.aboutConsultant?.qualification || '',
    specialisation: specialist?.aboutConsultant?.specialisation || ''
  });

  const [open, setOpen] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState('');
  const [snackBarType, setSnackBarType] = useState('success');
  const { user } = useAuth();

  const handleSubmit = (event) => {
    const specialistRequest = {
      consultantName: {
        firstName: consultantName?.firstName,
        lastName: consultantName?.lastName
      },
      email: email,
      password: 'Specialist@123',
      phoneNumber: {
        cell: phoneNumber?.cell,
        whatsapp: phoneNumber?.cell
      },
      refDoctorId: user?._id,
      centerAddress: {
        centerName: centerAddress.centerName,
        street: centerAddress.street,
        locality: centerAddress.locality,
        district: centerAddress.district,
        state: centerAddress.state,
        pincode: centerAddress.pincode
      },
      aboutConsultant: {
        qualification: aboutSpecialist.qualification,
        specialisation: aboutSpecialist.specialisation
      },
      role: 'SPECIALIST'
    };

    addSpecialist(specialistRequest, user?.authToken)
      .then((res) => {
        // console.log(res);
        if (res.data.status === 'success') {
          handleDialogSubmit();
        } else {
          setSnackBarMessage('Error in adding Doctor');
          setSnackBarType('error');
          showSnackBar();
        }
      })
      .catch((err) => {
        console.log(err);
        setSnackBarMessage('Error in adding Doctor');
        setSnackBarType('error');
        showSnackBar();
      });
    // console.log('submitted');
  };

  const updateDoctorSubmit = (event) => {
    const updateSpecialistRequest = {
      _id: specialist?._id,
      consultantName: {
        firstName: consultantName?.firstName,
        lastName: consultantName?.lastName
      },

      doctorProfile: profileImage,
      phoneNumber: {
        cell: phoneNumber?.cell,
        whatsapp: phoneNumber?.whatsapp
      },
      centerAddress: {
        centerName: centerAddress?.centerName,
        street: centerAddress?.street,
        locality: centerAddress?.locality,
        district: centerAddress?.district,
        state: centerAddress?.state,
        pincode: centerAddress?.pincode
      },
      aboutConsultant: {
        qualification: aboutSpecialist?.qualification,
        specialisation: aboutSpecialist?.specialisation
      }
    };

    updateSpecialist(updateSpecialistRequest, user?.authToken)
      .then((res) => {
        if (res.data.status === 'success') {
          setSnackBarMessage('Patient updated Successfully');
          setSnackBarType('success');
          showSnackBar();
          fetchSpecialistDetails();
          handleCloseDialog();
        } else {
          setSnackBarMessage('Error in updating Patient details');
          setSnackBarType('error');
          showSnackBar();
        }
      })
      .catch((err) => {
        console.log(err);
        setSnackBarMessage('Error in updating Patient');
        setSnackBarType('error');
        showSnackBar();
      });
    // console.log('submitted');
  };

  function showSnackBar() {
    setOpen(true);
  }
  function handleClose(_, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  }

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64Data = reader.result.split(',')[1];
        setProfileImage(base64Data);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleNameChange = (e) => {
    const capitalizedInput = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1);
    setConsultantName({ ...consultantName, firstName: capitalizedInput });
  };

  return (
    <div>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={snackBarType}
          sx={{ width: '100%' }}
          variant="filled"
        >
          {snackBarMessage}
        </Alert>
      </Snackbar>
      <SimpleCard>
        <Avatar
          alt="Clinic"
          src={`data:image/jpeg;base64,${profileImage}`}
          style={{ width: '150px', height: '150px', margin: 'auto' }}
        />
        <input
          accept="image/*"
          style={{ display: 'none' }}
          id="contained-button-file"
          type="file"
          onChange={handleImageChange}
        />
        <label htmlFor="contained-button-file">
          <Button variant="contained" component="span" style={{ marginTop: '20px', backgroundColor:'#66b5a3', color:'white' }}>
            Upload Logo
          </Button>
        </label>
      </SimpleCard>
      {/* <Box py="12px" /> */}

      <ValidatorForm onSubmit={specialist ? updateDoctorSubmit : handleSubmit} onError={() => null}>
        <Typography variant="h6" gutterBottom>
          Personal Details
        </Typography>

        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            <TextField
              type="text"
              name="FirstName"
              id="standard-basic"
              label="First Name"
              variant="outlined"
              fullWidth
              value={consultantName?.firstName}
              onChange={handleNameChange}
              errorMessages={['this field is required']}
              validators={['required']}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              type="text"
              name="LastName"
              id="standard-basic"
              label="Last Name"
              variant="outlined"
              fullWidth
              value={consultantName.lastName}
              onChange={(e) => setConsultantName({ ...consultantName, lastName: e.target.value })}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              type="text"
              name="email"
              label="Email"
              variant="outlined"
              fullWidth
              value={email || ''}
              onChange={(val) => setEmail(val.target.value)}
              validators={['required', 'isEmail']}
              errorMessages={['this field is required', 'email is not valid']}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              type="number"
              name="cellNumber"
              id="standard-basic"
              value={phoneNumber.cell}
              onChange={(val) => setPhoneNumber({ ...phoneNumber, cell: val.target.value })}
              label="PhoneNumber"
              validators={['required', 'isNumber', 'matchRegexp:^\\d{10}$']}
              errorMessages={[
                'This field is required',
                'Must be a number',
                'Phone number must be 10 digits'
              ]}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              type="text"
              name="centerAddress"
              id="standard-basic"
              value={centerAddress.centerName}
              onChange={(val) =>
                setCenterAddress({ ...centerAddress, centerName: val.target.value })
              }
              errorMessages={['this field is required']}
              label="Center Name"
              validators={['required']}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              type="text"
              name="StreetAddress"
              id="standard-basic"
              value={centerAddress.street}
              onChange={(val) => setCenterAddress({ ...centerAddress, street: val.target.value })}
              label="Street"
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              type="text"
              name="Locality"
              id="standard-basic"
              value={centerAddress.locality}
              onChange={(val) => setCenterAddress({ ...centerAddress, locality: val.target.value })}
              label="Locality"
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              type="text"
              name="District"
              id="standard-basic"
              value={centerAddress.district}
              onChange={(val) => setCenterAddress({ ...centerAddress, district: val.target.value })}
              label="District"
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              type="text"
              name="State"
              id="standard-basic"
              value={centerAddress.state}
              onChange={(val) => setCenterAddress({ ...centerAddress, state: val.target.value })}
              label="State"
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              type="number"
              name="Pincode"
              id="standard-basic"
              value={centerAddress.pincode}
              onChange={(val) => setCenterAddress({ ...centerAddress, pincode: val.target.value })}
              errorMessages={['this field is required']}
              label="Pincode"
              validators={['required']}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              type="text"
              name="Qualification"
              id="standard-basic"
              value={aboutSpecialist.qualification}
              onChange={(val) =>
                setAboutSpecialist({ ...aboutSpecialist, qualification: val.target.value })
              }
              errorMessages={['this field is required']}
              label="Qualification"
              validators={['required']}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              type="text"
              name="Specialisation"
              id="standard-basic"
              value={aboutSpecialist.specialisation}
              onChange={(val) =>
                setAboutSpecialist({ ...aboutSpecialist, specialisation: val.target.value })
              }
              errorMessages={['this field is required']}
              label="Specialisation"
              validators={['required']}
            />
          </Grid>
        </Grid>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={handleCloseDialog} color="primary" style={{color : '#66b5a3'}}>
            Cancel
          </Button>
          <Button color="primary" variant="contained" type="submit" style={{backgroundColor: '#66b5a3', color:'white'}}>
            <Span sx={{ pl: 1, textTransform: 'capitalize' }}>
              {specialist ? 'Save Changes' : 'Add Specialist'}
            </Span>
          </Button>
        </div>
      </ValidatorForm>
    </div>
  );
};

export default SpecialistForm;
